



































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'

@Component({
    name: 'ldw-footer'
})

export default class FooterComponent extends Vue {
    // data
    private actualYear: number = new Date().getFullYear()
}
